export const layoutVariants = {
  variants: {
    p: {
      0: "oui-p-0",
      1: "oui-p-1",
      2: "oui-p-2",
      3: "oui-p-3",
      4: "oui-p-4",
      5: "oui-p-5",
      6: "oui-p-6",
      7: "oui-p-7",
      8: "oui-p-8",
      9: "oui-p-9",
      10: "oui-p-10",
    },
    px: {
      0: "oui-px-0",
      1: "oui-px-1",
      2: "oui-px-2",
      3: "oui-px-3",
      4: "oui-px-4",
      5: "oui-px-5",
      6: "oui-px-6",
      7: "oui-px-7",
      8: "oui-px-8",
      9: "oui-px-9",
      10: "oui-px-10",
    },
    py: {
      0: "oui-py-0",
      1: "oui-py-1",
      2: "oui-py-2",
      3: "oui-py-3",
      4: "oui-py-4",
      5: "oui-py-5",
      6: "oui-py-6",
      7: "oui-py-7",
      8: "oui-py-8",
      9: "oui-py-9",
      10: "oui-py-10",
    },
    pt: {
      0: "oui-pt-0",
      1: "oui-pt-1",
      2: "oui-pt-2",
      3: "oui-pt-3",
      4: "oui-pt-4",
      5: "oui-pt-5",
      6: "oui-pt-6",
      7: "oui-pt-7",
      8: "oui-pt-8",
      9: "oui-pt-9",
      10: "oui-pt-10",
    },
    pb: {
      0: "oui-pb-0",
      1: "oui-pb-1",
      2: "oui-pb-2",
      3: "oui-pb-3",
      4: "oui-pb-4",
      5: "oui-pb-5",
      6: "oui-pb-6",
      7: "oui-pb-7",
      8: "oui-pb-8",
      9: "oui-pb-9",
      10: "oui-pb-10",
    },
    pl: {
      0: "oui-pl-0",
      1: "oui-pl-1",
      2: "oui-pl-2",
      3: "oui-pl-3",
      4: "oui-pl-4",
      5: "oui-pl-5",
      6: "oui-pl-6",
      7: "oui-pl-7",
      8: "oui-pl-8",
      9: "oui-pl-9",
      10: "oui-pl-10",
    },
    pr: {
      0: "oui-pr-0",
      1: "oui-pr-1",
      2: "oui-pr-2",
      3: "oui-pr-3",
      4: "oui-pr-4",
      5: "oui-pr-5",
      6: "oui-pr-6",
      7: "oui-pr-7",
      8: "oui-pr-8",
      9: "oui-pr-9",
      10: "oui-pr-10",
    },
    m: {
      0: "oui-m-0",
      1: "oui-m-1",
      2: "oui-m-2",
      3: "oui-m-3",
      4: "oui-m-4",
      5: "oui-m-5",
      6: "oui-m-6",
      7: "oui-m-7",
      8: "oui-m-8",
      9: "oui-m-9",
      10: "oui-m-10",
    },
    mx: {
      0: "oui-mx-0",
      1: "oui-mx-1",
      2: "oui-mx-2",
      3: "oui-mx-3",
      4: "oui-mx-4",
      5: "oui-mx-5",
      6: "oui-mx-6",
      7: "oui-mx-7",
      8: "oui-mx-8",
      9: "oui-mx-9",
      10: "oui-mx-10",
    },
    my: {
      0: "oui-my-0",
      1: "oui-my-1",
      2: "oui-my-2",
      3: "oui-my-3",
      4: "oui-my-4",
      5: "oui-my-5",
      6: "oui-my-6",
      7: "oui-my-7",
      8: "oui-my-8",
      9: "oui-my-9",
      10: "oui-my-10",
    },
    mt: {
      0: "oui-mt-0",
      1: "oui-mt-1",
      2: "oui-mt-2",
      3: "oui-mt-3",
      4: "oui-mt-4",
      5: "oui-mt-5",
      6: "oui-mt-6",
      7: "oui-mt-7",
      8: "oui-mt-8",
      9: "oui-mt-9",
      10: "oui-mt-10",
    },
    mb: {
      0: "oui-mb-0",
      1: "oui-mb-1",
      2: "oui-mb-2",
      3: "oui-mb-3",
      4: "oui-mb-4",
      5: "oui-mb-5",
      6: "oui-mb-6",
      7: "oui-mb-7",
      8: "oui-mb-8",
      9: "oui-mb-9",
      10: "oui-mb-10",
    },
    ml: {
      0: "oui-ml-0",
      1: "oui-ml-1",
      2: "oui-ml-2",
      3: "oui-ml-3",
      4: "oui-ml-4",
      5: "oui-ml-5",
      6: "oui-ml-6",
      7: "oui-ml-7",
      8: "oui-ml-8",
      9: "oui-ml-9",
      10: "oui-ml-10",
    },
    mr: {
      0: "oui-mr-0",
      1: "oui-mr-1",
      2: "oui-mr-2",
      3: "oui-mr-3",
      4: "oui-mr-4",
      5: "oui-mr-5",
      6: "oui-mr-6",
      7: "oui-mr-7",
      8: "oui-mr-8",
      9: "oui-mr-9",
      10: "oui-mr-10",
    },
    grow: {
      true: "oui-grow",
    },
  },
};
